import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from 'languages/i18n';
import Main from 'pages/Main';
import { unregister } from './registerServiceWorker';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <I18nextProvider i18n={i18n}>
    <Suspense fallback={<span>Cargando…</span>}>
      <Router basename={process.env.PUBLIC_URL}>
        <Routes>
          <Route path='/inicio' element={<Main />} />
          <Route path="*" element={<Navigate to="/inicio" replace />} />
        </Routes>
      </Router>
    </Suspense>
  </I18nextProvider>
);

unregister();
